import { Link2 } from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { linkUnfurlWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  linkUnfurlWeb,
  {
    UnfurlCard: () => import('./components/UnfurlCard').then((m) => ({ default: m.UnfurlCard })),
  },
  {
    icons: { Link2 },
  },
);
